<template>
  <list-view-cell class="contract-cell" :context-menu-items="contextMenuItems">
    <h3 class="font-bold text-sm">{{ contract.name }}</h3>
    <div class="mt-1" v-if="contract.place">
      <p class="text-sm">
        {{ contract.place.address_1 }}
        <template v-if="contract.place.address_2">
          - {{ contract.place.address_2 }}
        </template>
      </p>
      <p class="text-sm">
        {{ contract.place.city }}, {{ contract.place.state }}
        {{ contract.place.zip }}
        <a
          class="ml-1 text-red hover-bold"
          :href="generateGoogleMapsUrl(contract.place)"
        >
          <i class="fal fa-map-marker-alt"></i>
        </a>
      </p>
    </div>
    <p class="text-sm mt-1" v-if="contract.email">
      <a class="text-red hover-bold" :href="`mailto:${contract.email}`">
        {{ contract.email }}
      </a>
    </p>
    <p
      class="text-sm"
      v-if="contract.primary_phone && contract.primary_phone.number"
    >
      {{ contract.primary_phone.number }}
    </p>
  </list-view-cell>
</template>

<script>
import { Contract } from "../../../models/Contract";
import { ContextMenuItem } from "../../../helper-classes/ContextMenuItem";
import ContractForm from "../../../views/contracts/ContractForm";
import ContractDeleteModal from "../../../views/contracts/ContractDeleteModal";
import ListViewCell from "./ListViewCell";

export default {
  name: "ContractCell",
  components: { ListViewCell },
  props: {
    contract: { type: Contract, required: true }
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("view", () => {
          this.$router.push({
            name:
              this.userType === "admin"
                ? "contracts-show"
                : "contract-contacts",
            params: { id: this.contract.id, contract: this.contract }
          });
        }),
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ContractForm,
            createEditComponentData: this.contract,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: ContractDeleteModal,
            bodyComponentData: this.contract,
            isShown: true
          });
        })
      ]
    };
  },
  computed: {
    userType() {
      return this.$store.state.userType;
    }
  }
};
</script>
